import type { ExperimentalQueries } from '../__types__/ExperimentalQueries';

export const experimentalOnboardingSpaceBlueprints: ExperimentalQueries['experimentalOnboardingSpaceBlueprints'] =
	async (_, __, { network }) => {
		try {
			const res = await network.cfetch(
				`/wiki/rest/create-dialog/1.0/space-blueprint/dialog/web-items`,
				{
					method: 'GET',
				},
			);
			const data = await res.json();
			return { spaceBlueprints: data };
		} catch (e) {
			throw new Error(`/space-blueprint/dialog/web-items ${e.message}`);
		}
	};
